<template>
  <v-app-bar app clipped-left color="dark-grey" dense style="z-index:6">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-app-bar-nav-icon v-on="on" @click.stop="drawer= !drawer" />
      </template>
      <span v-if="drawer">Cerrar lista</span>
      <span v-else>Mostrar lista</span>
    </v-tooltip>
    <v-icon class="mx-4">fab fa-youtube</v-icon>
    <v-toolbar-title class="align-center">
      <v-img src="../../../public/static/logo_ultraip.png"/>
    </v-toolbar-title>
    <v-spacer />
    <v-row 
    align="center"
    justify="end"
    v-if="((this.$store.state.user !== null)&&(this.$store.state.user !== undefined))"
    >
      <v-col cols="4" lg="2" class="text-right" style="font-size:18px">
          {{this.$store.state.user.profile.name}}
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="3">
            <v-btn :small="mobile" @click.native="closeSession" text>
              <span style="font-size:11px" class="text-capitalize ml-1  mt-1 white-text" 
                align-self-right>Cerrar sesión</span>
            </v-btn>
       <!-- <v-menu bottom left rounded>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list color="#f7f7f7" class="mt-9 py-0" rounded>
              <v-list-item
                @click.native="closeSession"
                class="ma-0"
              >
                <v-list-item-title class="logout black--text">Cerrar Sesión</v-list-item-title>
                
              </v-list-item>
            </v-list>
          </v-menu>-->
      </v-col>
      <v-col cols=1 v-if="mobile">
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>
export default {
  data(){
    return {

    }
  },
  computed: {
    drawer:{
      get(){
        return this.$store.getters.getDrawer
      },
      set(value){
        this.$store.commit('setDrawer', value)
      }
    },
    mobile: {
      get(){
        return ((this.$vuetify.breakpoint.name=="xs")||(this.$vuetify.breakpoint.name=="sm"))
      }
    },
  },
  methods: {
    closeSession(){
      this.$store.dispatch('signOut')
    },
  }
  
}
</script>
<style scoped>
  .logout{
    font-size: 12px!important;
    cursor: pointer!important;
  }
</style>